





































































import { Component, Vue, Watch } from 'vue-property-decorator';
import cCard from '@/components/default/Card.vue';
import '@/types';
import Article from '@/modules/articles/classes/Article';
import LabourCostCard from '@/modules/articles/components/ArticleLabourCostCard.vue';
import ArticleComposition from '@/modules/articles/components/ArticleComposition.vue';
import notificationService from '@/services/notificationService';
import { DxNavBar } from 'devextreme-vue';
import { DxForm, DxColCountByScreen } from 'devextreme-vue/form';

import EventLogsTable from '@/modules/shared/eventlogs/components/EventLogsTable.vue';
import { EventLogsObjectType } from '@/modules/shared/eventlogs/enums';

import ArticleBasicInfoForm from '@/modules/articles/components/ArticleBasicInfoForm.vue';
import { ArticlesClient, CopyArticleCommand, ArticleTranslationDto } from '@/data/web-api-client';

@Component({
  components: {
    cCard,
    LabourCostCard,
    ArticleComposition,
    DxNavBar,
    ArticleBasicInfoForm,
    EventLogsTable,
    DxColCountByScreen,
    DxForm
  },
})
export default class ArticleDetailsPage extends Vue {
  public article: Article = new Article();
  public loading: boolean = true;
  public navIndex: number = 0;
  translationsForm: any = {
    articleTranslations: []
  };
  languages: any[] = [];
  leftPositionBottomBar = 0;
  dirty = false;
  saving = false;
  articlesClient = new ArticlesClient(undefined, this.$axios);
  articleTranslations: ArticleTranslationDto[] = [];
  initialized = false;

  public mounted() {
    if (document) {
      const bar = document.getElementById("savebar");

      if (bar) {
        const rect = bar.getBoundingClientRect();
        this.leftPositionBottomBar -= rect.left;
      }
    }

    this.loadData();
  }

  public async loadData() {
    const self = this;
    this.loading = true;
    this.languages = this.$store.getters['catalogs/list']('Languages')?.values ?? [];

    // Load if we have an ID parameter
    if (this.$route.params.id) {
      this.article = Object.assign(this.article, this.$store.getters['articles/item'](this.$route.params.id));
      this.article.calculateMissingParameters(this.projecttypes, this.settings.defaultMargin);
      this.articleTranslations = await this.articlesClient.getTranslations(this.article.id);
    } else {
      this.article.calculateMissingParameters(this.projecttypes, this.settings.defaultMargin);
    }

    setTimeout(() => {
      self.loading = false;
      this.initialized = true;
    }, 250);
  }

  public storeUpdate() {
    this.$store.commit('articles/updateItem', this.article);
  }

  public async copy() {
    const newName = prompt(this.$t('objects.articles.EnterNameMsg', '') as string);

    if (newName && newName !== '') {
      try {
        const command = new CopyArticleCommand({
          id: this.article.id,
          name: newName,
        });

        const result = await new ArticlesClient(undefined, this.$axios).copy(command);
        this.$store.commit('articles/addItem', result);
        notificationService.saved();
        this.$router.push({ path: `/articles/${result.id}` });
      } catch {
        notificationService.failedToSave();
      }
    }
  }

  public async save() {
    let success = false;
    if (this.article.id && this.article.id !== '') {
      // update
      success = await this.$store.dispatch('articles/update', this.article);
      const updatedArticle = this.$store.getters['articles/item'](this.$route.params.id);
      // only update if variant is already added
      updatedArticle.variants.forEach((variant: IArticleVariant) => {
        const foundVariant = this.article.variants.find((o: IArticleVariant) => o.name === variant.name);
        if (foundVariant) {
          foundVariant.salesPrices = variant.salesPrices;
        } else {
          this.article.variants.push(variant);
        }
      });

      this.article.labourCosts = this.$store.getters['articles/item'](this.$route.params.id).labourCosts;
    } else {
      success = await this.$store.dispatch('articles/create', this.article);

      if (success) {
        this.$router.push('/articles/' + success);
      }
    }
  }

  async saveTranslations() {
    const translations = this.translationsForm.articleTranslations.map((t: any) => ArticleTranslationDto.fromJS({
      language: t.language,
      name: t.name,
      description: t.description
    }));

    await this.articlesClient.updateTranslations(this.article.id, translations);

    this.dirty = false;
  }

  formChanged(value: any) {
    if (!this.initialized) {
      return;
    }

    this.dirty = true;
  }

  get title() {
    return `${this.$t('objects.articles.EditTitle')}: ${!this.loading ? this.article.name : ''}`;
  }

  get settings() {
    return this.$store.getters['settings/data'];
  }

  get projecttypes() {
    const catalog = this.$store.getters['catalogs/list']('ProjectTypes');
    return catalog ? catalog.values : [];
  }

  get id() {
    return this.$route.params.id;
  }

  get historyConfig(): IEventLogQuery {
    return {
      objectId: this.id,
      type: EventLogsObjectType.Article,
    };
  }

  get navbarItems() {
    return [
      { icon: 'fas fa-info-circle', text: 'Info' },
      { icon: 'fas fa-hard-hat', text: 'Arbeidskosten' },
      { icon: 'fas fa-list', text: 'Samenstellingen' },
      { icon: 'fas fa-history', text: 'Geschiedenis' },
    ];
  }

  get translationsGroup() {
    const items: any[] = [];

    for (let index = 0; index < this.languages.length; index++) {
      this.translationsForm.articleTranslations[index] = {
        language: this.languages[index],
        name: '',
        description: ''
      };

      const existingTranslation = this.articleTranslations?.find(t => t.language == this.languages[index]);

      if (existingTranslation) {
        this.translationsForm.articleTranslations[index].name = existingTranslation.name;
        this.translationsForm.articleTranslations[index].description = existingTranslation.description;
      }

      items.push({
        itemType: 'group',
        caption: this.languages[index],
        items: [
          {
            itemType: 'simple',
            dataField: `articleTranslations[${index}].name`,
            label: {
              text: this.$t('objects.articles.Name')
            }
          },
          {
            itemType: 'simple',
            dataField: `articleTranslations[${index}].description`,
            label: {
              text: this.$t('objects.articles.Description')
            }
          }
        ]
      });
    }

    return items;
  }

  @Watch('id')
  public onPropertyChanged() {
    this.loadData();
  }
}
